const DARK_SCHEME = "(prefers-color-scheme: dark)";
const LUMINANCE_MIDPOINT = 128;
const isDarkHex = (hex)=>{
    const [red, green, blue] = [
        1,
        3,
        5
    ].map((offset)=>parseInt(hex.slice(offset, offset + 2), 16));
    return 0.299 * red + 0.587 * green + 0.114 * blue < LUMINANCE_MIDPOINT;
};
const isOfficeDark = ()=>{
    const officeTheme = Office.context?.officeTheme;
    if (!officeTheme?.bodyBackgroundColor) return undefined;
    return officeTheme.isDarkTheme ?? isDarkHex(officeTheme.bodyBackgroundColor);
};
const applyTheme = (isDark)=>{
    document.documentElement.dataset.theme = isDark ? "dark" : "light";
};
/** Word's officeTheme lags a theme switch and raises no event, so the colour scheme drives live changes. */ export function followWordTheme() {
    const colourScheme = matchMedia(DARK_SCHEME);
    let wasOfficeDark = isOfficeDark();
    applyTheme(wasOfficeDark ?? colourScheme.matches);
    colourScheme.addEventListener("change", (event)=>applyTheme(event.matches));
    const recheckOffice = ()=>{
        const isNowOfficeDark = isOfficeDark();
        if (isNowOfficeDark === undefined || isNowOfficeDark === wasOfficeDark) return;
        wasOfficeDark = isNowOfficeDark;
        applyTheme(isNowOfficeDark);
    };
    window.addEventListener("focus", recheckOffice);
    document.addEventListener("visibilitychange", recheckOffice);
}
